import LiaIntegrationsAPI from '../../api/liaIntegrations';

const state = {
  records: [],
  providers: [],
  uiFlags: {
    isFetching: false,
    isFetchingProviders: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
    isTesting: false,
  },
};

const getters = {
  getIntegrations: $state => $state.records,
  getProviders: $state => $state.providers,
  getIntegrationById: $state => id =>
    $state.records.find(i => i.id === Number(id)),
  getActiveIntegrations: $state => $state.records.filter(i => i.active),
  getUIFlags: $state => $state.uiFlags,
};

const mutations = {
  setIntegrations($state, data) {
    $state.records = data;
  },
  setProviders($state, data) {
    $state.providers = data;
  },
  addIntegration($state, data) {
    $state.records.push(data);
  },
  updateIntegration($state, data) {
    const index = $state.records.findIndex(i => i.id === data.id);
    if (index !== -1) {
      $state.records.splice(index, 1, data);
    }
  },
  removeIntegration($state, id) {
    $state.records = $state.records.filter(i => i.id !== id);
  },
  setUIFlag($state, { key, value }) {
    $state.uiFlags[key] = value;
  },
};

const actions = {
  async fetch({ commit }) {
    commit('setUIFlag', { key: 'isFetching', value: true });
    try {
      const response = await LiaIntegrationsAPI.get();
      commit('setIntegrations', response.data);
    } catch (error) {
      throw new Error(error.response?.data?.error || error.message);
    } finally {
      commit('setUIFlag', { key: 'isFetching', value: false });
    }
  },

  async fetchProviders({ commit }) {
    commit('setUIFlag', { key: 'isFetchingProviders', value: true });
    try {
      const response = await LiaIntegrationsAPI.getProviders();
      commit('setProviders', response.data);
    } catch (error) {
      throw new Error(error.response?.data?.error || error.message);
    } finally {
      commit('setUIFlag', { key: 'isFetchingProviders', value: false });
    }
  },

  async create({ commit }, data) {
    commit('setUIFlag', { key: 'isCreating', value: true });
    try {
      const response = await LiaIntegrationsAPI.create(data);
      commit('addIntegration', response.data);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || error.message);
    } finally {
      commit('setUIFlag', { key: 'isCreating', value: false });
    }
  },

  async update({ commit }, { id, ...data }) {
    commit('setUIFlag', { key: 'isUpdating', value: true });
    try {
      const response = await LiaIntegrationsAPI.update(id, data);
      commit('updateIntegration', response.data);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || error.message);
    } finally {
      commit('setUIFlag', { key: 'isUpdating', value: false });
    }
  },

  async delete({ commit }, id) {
    commit('setUIFlag', { key: 'isDeleting', value: true });
    try {
      await LiaIntegrationsAPI.delete(id);
      commit('removeIntegration', id);
    } catch (error) {
      throw new Error(error.response?.data?.error || error.message);
    } finally {
      commit('setUIFlag', { key: 'isDeleting', value: false });
    }
  },

  async testConnection({ commit }, id) {
    commit('setUIFlag', { key: 'isTesting', value: true });
    try {
      const response = await LiaIntegrationsAPI.testConnection(id);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || error.message);
    } finally {
      commit('setUIFlag', { key: 'isTesting', value: false });
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
